import React, { useContext } from 'react';
import RoomRow from './RoomRow/RoomRow';
import { AppContext } from 'App.context';
import useRoomsTableHook from './RoomsTable.hook';

import './RoomsTable.css';

export default function RoomsTable({ rooms, onAddRoom }) {
  const {
    appActions: { translate },
  } = useContext(AppContext);
  const { state, actions } = useRoomsTableHook({ rooms, onAddRoom });
  return (
    <div className="rooms-table-container">
      <table className="rooms-table">
        <thead>
          <tr>
            <th>{translate('createBooking.steps.selectRooms.room')}</th>
            <th>{translate('createBooking.steps.selectRooms.price')} (€)</th>
            {/* <th>{translate('createBooking.steps.selectRooms.available')}</th> */}
            <th>{translate('createBooking.steps.selectRooms.adults')}</th>
            <th>{translate('createBooking.steps.selectRooms.children')}</th>
            {/* <th>{translate('createBooking.steps.selectRooms.rooms')}</th> */}
            <th></th>
          </tr>
        </thead>
        <tbody>
          {rooms.map((room, index) => (
            <RoomRow
              key={index}
              index={index}
              room={room}
              controls={state.tableControls[index]}
              onControlChange={actions.onControlChange}
              onAddRoom={() => {
                actions.handleAddBooking({ index });
              }}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
